import * as styles from './styles.css';

import { Spinner } from '@cian/ui-kit';

export function ListingPreloader() {
  return (
    <div className={styles['container']}>
      <Spinner size={32} />
    </div>
  );
}
